define('meeting-modal/tab-options/audio-tab',['require','api-access','api-access','api-access','country-text','lib/audio/audio-default-countries','lib/audio/available-countries-filter','lib/audio/audio-default-countries-call-me','meeting-modal/country-selector/country-selector','knockout','lodash','i18next'],function (require) {
    var userApi = require('api-access').user;
    var meetingsApi = require('api-access').meetings;
    var commerceApi = require('api-access').commerce;
    var countryText = require('country-text');
    var audioDefaultCountries = require('lib/audio/audio-default-countries');
    var availableCountriesFilter = require('lib/audio/available-countries-filter');
    var dialOutDefaultCountriesFilter = require('lib/audio/audio-default-countries-call-me');
    var CountrySelector = require('meeting-modal/country-selector/country-selector');

    var ko = require('knockout');
    var _ = require('lodash');
    var i18n = require('i18next');

    /**
     * If a meetingId is supplied, the module will assume edit behavior.
     * For schedule behavior, do not supply a meetingId.
     */
    var AudioTab = function (meetingId) {
        var self = this;

        // "provided" or "private"
        self.audioType = ko.observable();

        self.privateMessage = ko.observable().extend({
            required: {
                message: i18n.t('error.audio.privatemessage.required'),
                onlyIf: function () {
                    return self.audioType() === 'private';
                }
            },
            restrictedRegex: {
                onlyIf: function () {
                    return self.audioType() === 'private';
                }
            }
        });

        // Array of selected modes: VOIP, DIALOUT, TOLL, or TOLLFREE
        self.selectedAudioModes = ko.observableArray().extend({
            minLength: {
                params: 1,
                onlyIf: function () {
                    return self.audioType() === 'provided';
                },
                message: i18n.t('settings.audio.builtin.required')
            }
        });

        self.isVoipAllowed = ko.observable();
        self.isTollAllowed = ko.observable();
        self.isTollFreeAllowed = ko.observable();
        self.isPrivateAllowed = ko.observable();

        // Dialout
        self.showDialout = ko.observable();
        self.isDialOutSelected = ko.observable();
        self.isDialOutAllowed = ko.observable();
        self.isDialOutInternationalEnabled = ko.observable(false);

        /**
         * Country Selector
         */
        // Will contain the country-selector module if it is active.
        self.countrySelector = ko.observable();

        var allowedTollCountries;
        var allowedTollFreeCountries;
        var allowedDialOutCountries;

        // Array of selected country codes: ['DE', 'US', ...]
        self.selectedTollCountries = ko.observableArray();
        self.selectedTollFreeCountries = ko.observableArray();
        self.selectedDialOutCountries = ko.observableArray();

        self.preferredTollCountry = ko.observable();
        self.preferredTollFreeCountry = ko.observable();

        /**
         * Format the list of countries for display with rules in the country-text module.
         * For example: "France and 2 other countries."
         */
        self.tollCountryText = ko.computed(function () {
            return countryText(self.selectedTollCountries(), self.preferredTollCountry());
        });

        self.tollFreeCountryText = ko.computed(function () {
            return countryText(self.selectedTollFreeCountries(), self.preferredTollFreeCountry());
        });

        self.dialOutCountryText = ko.computed(function () {
            return countryText(self.selectedDialOutCountries(), null);
        });

        self.switchToTollCountrySelector = function () {
            self.countrySelector(
                new CountrySelector(allowedTollCountries, self.selectedTollCountries(), 'TOLL')
            );
        };

        self.switchToTollFreeCountrySelector = function () {
            self.countrySelector(
                new CountrySelector(allowedTollFreeCountries, self.selectedTollFreeCountries(), 'TOLLFREE')
            );
        };

        self.switchToDialOutCountrySelector = function () {
            self.countrySelector(
                new CountrySelector(allowedDialOutCountries, self.selectedDialOutCountries(), 'DIALOUT')
            );
        };

        // Grabs the selected countries from the active country-selector module before deactivating it.
        self.saveCountrySelector = function () {
            var newSelection = self.countrySelector().selectedCountries();

            if (self.countrySelector().selectorType === 'TOLL') {
                self.selectedTollCountries(newSelection);
            } else if (self.countrySelector().selectorType === 'TOLLFREE') {
                self.selectedTollFreeCountries(newSelection);
            } else if (self.countrySelector().selectorType === 'DIALOUT') {
                self.selectedDialOutCountries(newSelection);
            }
            self.countrySelector(null);
        };

        self.cancelCountrySelector = function () {
            self.countrySelector(null);
            /* Recenter modal is required because of the issue of not able to */
            /* see Save and Cancel on smaller resolutions */
            self.centerModal();
        };
        /**
         *
         */
        // Should contain all validated observables.
        // Parent modules can compose this object to determine if any errors exist.
        self.validation = ko.validatedObservable({
            selectedAudioModes: self.selectedAudioModes,
            privateMessage: self.privateMessage
        });

        /**
         * Returns relevant data, formatted for consumption by the API.
         */
        self.buildOptions = function () {
            var audioOptions = {};

            if (self.audioType() === 'private') {
                audioOptions = {
                    audioType: 'private',
                    privateMessage: self.privateMessage()
                };
            } else {
                /**
                 * How this module organizes audio logic:
                 *
                 * self.audioType is either "private" or "provided".
                 * For the provided type, self.selectedAudioModes is a relevant array of selections:
                 *      ['VOIP', 'TOLL', TOLLFREE']
                 *
                 * How the API organizes audio logic:
                 *
                 * audioType is a string with these options:
                 *      "private", "voipAndPstn", "voip", "pstn"
                 *
                 * The "pstn" string is included if either toll or toll-free is set.
                 * In order to distinguish between between toll or toll-free,
                 * the API will look for the presence of tollCountries or TollFreeCountries array.
                 */

                // TODO: Might be a good idea to put this logic into a separate module.
                var isSelectedVoip = self.selectedAudioModes.indexOf('VOIP') > -1;
                var isSelectedToll = self.selectedAudioModes.indexOf('TOLL') > -1;
                var isSelectedTollFree = self.selectedAudioModes.indexOf('TOLLFREE') > -1;

                if (isSelectedVoip && (isSelectedTollFree || isSelectedToll)) {
                    audioOptions.audioType = 'voipAndPstn';
                } else if (isSelectedVoip) {
                    audioOptions.audioType = 'voip';
                } else {
                    audioOptions.audioType = 'pstn';
                }

                if (isSelectedToll) {
                    audioOptions.tollCountries = self.selectedTollCountries();
                }

                if (isSelectedTollFree) {
                    audioOptions.tollFreeCountries = self.selectedTollFreeCountries();
                }

                audioOptions.isDialOut = self.isDialOutSelected();
                if (self.showDialout() && self.isDialOutSelected()) {
                    audioOptions.dialOutCountries = self.selectedDialOutCountries();
                }
            }

            return {
                audio: audioOptions
            };
        };

        self.centerModal = function () {
            $(window).trigger('resize');
        };

        self.compositionComplete = function () {
            self.centerModal();
        };

        self.activate = function () {
            var activationPromise = $.Deferred();
            var billingCountry;

            $.when(userApi.settings(), userApi.me()).then(function (userSettingsResponse, userMeResponse) {
                var userSettings = userSettingsResponse[0];
                /* eslint-disable no-unused-vars */
                // Keeping this unused variable so the audio-tab doesn't return undefined
                var userMe = userMeResponse[0];
                /* eslint-enable */

                commerceApi.getBilling()
                    .then(function (billing) {
                        billingCountry = billing.country;
                    })
                    .always(function () {
                        self.isVoipAllowed(_.includes(userSettings.audio.allowedModes, 'VOIP'));
                        self.isTollAllowed(_.includes(userSettings.audio.allowedModes, 'TOLL'));
                        self.isTollFreeAllowed(_.includes(userSettings.audio.allowedModes, 'TOLLFREE'));
                        self.isPrivateAllowed(_.includes(userSettings.audio.allowedModes, 'PRIVATE'));
                        self.isDialOutAllowed(_.includes(userSettings.audio.allowedModes, 'DIALOUT'));
                        if (userSettings.isDialOutInternationalEnabled) {
                            self.isDialOutInternationalEnabled(userSettings.isDialOutInternationalEnabled);
                        }
                        // Dialout settings
                        self.showDialout(userSettings.isDialOutEnabled && userSettings.isDialOutProvisioned);
                        self.isDialOutSelected(userSettings.isDialOutDefault);

                        allowedTollCountries = userSettings.audio.allowedTollCountries;
                        allowedTollFreeCountries = userSettings.audio.allowedTollFreeCountries;
                        allowedDialOutCountries = userSettings.audio.allowedDialOutCountries;

                        self.preferredTollCountry(userSettings.audio.preferredTollCountry);
                        self.preferredTollFreeCountry(userSettings.audio.preferredTollFreeCountry);

                        // The default selected countries are based on what the user has set in settings.
                        // filtered by the allowed countries
                        // These will be overwritten later if editing an existing meeting.
                        if (self.isTollAllowed()) {
                            self.selectedTollCountries(
                                audioDefaultCountries(
                                    userSettings.audio.defaultTollCountries,
                                    userSettings.audio.allowedTollCountries,
                                    billingCountry
                                )
                            );
                        }

                        if (self.isTollFreeAllowed()) {
                            self.selectedTollFreeCountries(
                                audioDefaultCountries(
                                    userSettings.audio.defaultTollFreeCountries,
                                    userSettings.audio.allowedTollFreeCountries,
                                    billingCountry
                                )
                            );
                        }

                        if (self.isDialOutAllowed()) {
                            self.selectedDialOutCountries(
                                dialOutDefaultCountriesFilter(
                                    userSettings.audio.defaultDialOutCountries,
                                    userSettings.audio.allowedDialOutCountries
                                )
                            );
                        }

                        if (meetingId) {
                            // Edit Meeting. Apply that meeting's options.
                            meetingsApi.byIdFormatted(meetingId).then(function (meeting) {
                                var selectedTollCountries = [];
                                var selectedTollFreeCountries = [];
                                var selectedDialOutCountries = [];

                                if (self.isPrivateAllowed() && meeting.audio.audioType === 'private') {
                                    self.audioType('private');
                                    self.privateMessage(meeting.audio.privateMessage);
                                } else {
                                    self.audioType('provided');
                                }

                                if (self.isDialOutAllowed()) {
                                    self.selectedDialOutCountries(
                                        dialOutDefaultCountriesFilter(
                                            _.map(meeting.audio.dialOutInfo, 'country'),
                                            userSettings.audio.allowedDialOutCountries
                                    ));
                                }

                                /**
                                 * Format audio data from the API into something that is consumable by this module.
                                 * See comments in self.buildOptions for a more detailed breakdown.
                                 */
                                var audioType = meeting.audio.audioType;

                                if (self.isVoipAllowed()) {
                                    if (audioType === 'voip' || audioType === 'voipAndPstn') {
                                        self.selectedAudioModes.push('VOIP');
                                    }
                                }

                                _(meeting.audio.phoneNumbers).forEach(function (phoneNumber) {
                                    if (self.isTollFreeAllowed() && phoneNumber.tollFree) {
                                        selectedTollFreeCountries.push(phoneNumber.country);
                                    } else if (self.isTollAllowed()) {
                                        selectedTollCountries.push(phoneNumber.country);
                                    }
                                }).value();

                                if (self.isTollAllowed() && selectedTollCountries.length > 0) {
                                    if (audioType === 'pstn' || audioType === 'voipAndPstn') {
                                        self.selectedAudioModes.push('TOLL');
                                    }

                                    selectedTollCountries = availableCountriesFilter(allowedTollCountries,
                                        selectedTollCountries);
                                    self.selectedTollCountries(selectedTollCountries);
                                }

                                if (self.isTollFreeAllowed() && selectedTollFreeCountries.length > 0) {
                                    if (audioType === 'pstn' || audioType === 'voipAndPstn') {
                                        self.selectedAudioModes.push('TOLLFREE');
                                    }

                                    selectedTollFreeCountries = availableCountriesFilter(allowedTollFreeCountries,
                                        selectedTollFreeCountries);
                                    self.selectedTollFreeCountries(selectedTollFreeCountries);
                                }

                                if (self.isDialOutAllowed() && selectedDialOutCountries.length > 0) {
                                    if (audioType === 'pstn' || audioType === 'voipAndPstn') {
                                        self.selectedAudioModes.push('DIALOUT');
                                    }
                                    selectedDialOutCountries = availableCountriesFilter(
                                        allowedDialOutCountries,
                                        selectedDialOutCountries
                                    );
                                    self.selectedDialOutCountries(selectedDialOutCountries);
                                }

                                self.isDialOutSelected(meeting.audio.isDialOut);
                            });
                        } else {
                            // Schedule Meeting. Apply the options specified by the settings API.
                            if (userSettings.audio.defaultModes[0] === 'PRIVATE') {
                                self.audioType('private');
                                self.privateMessage(userSettings.audio.defaultModeratorPrivateMessage);
                            } else {
                                self.audioType('provided');
                                /**
                                 * For some reason, it's possible for an account to have audio modes active
                                 * that are not allowed.
                                 * Set the selected audio modes after removing prohibited ones.
                                 */
                                self.selectedAudioModes(
                                    _.intersection(userSettings.audio.defaultModes, userSettings.audio.allowedModes)
                                );
                            }
                        }

                        activationPromise.resolve();
                    });
            });
            return activationPromise;
        };
    };
    return AudioTab;
});

